import React, { Component } from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import { deleteWaitingUser, removeUserRenters } from '../../store/users/actions';
import { KOBOO_LIGHT_GREY } from '../../constants/colors';

const styles = () => ({
  fabProgress: {
    color: 'primary',
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1,
  },
  row: {
    backgroundColor: KOBOO_LIGHT_GREY,
  }
});

export class RenterAdminRow extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      deletingUserEmail: null,
    };
  }

  static propTypes = {
    classes: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    isWaiting: PropTypes.bool.isRequired,
  };

  // Lifecycle
  static getDerivedStateFromProps(props, state) {
    let newState = null;
    if (!props.sending && state.deletingUserEmail) {
      newState = { ...newState, deletingUserEmail: null };
    }
    return newState;
  }

  handleClickDeleteUser = (event, user) => {
    this.setState({ deletingUserEmail: user.email});
    if (this.props.isWaiting) {
      this.props.deleteWaitingUser(
        this.props.authUser.ma,
        user.renter_id,
        user
      );
    } else {
      this.props.removeUserRenters(user);
    }
    event.preventDefault();
  };

  // Handler

  render() {
    const { user, isWaiting, classes } = this.props;

    const { deletingUserEmail } = this.state;
    return (

      <TableRow
        className={ isWaiting ? classes.row : null }
        key={user.email}
        tabIndex={-1}
      >
        <TableCell>{user.email}</TableCell>
        <TableCell>{isWaiting ? 'En attente' : user.firstname}</TableCell>
        <TableCell>{isWaiting ? 'En attente' : user.lastname}</TableCell>
        <TableCell>{isWaiting ? 'En attente' : user.mobile}</TableCell>
        <TableCell>
          <Tooltip title="Supprimer">
            <IconButton
              id="button-delete"
              aria-label="delete"
              color="primary"
              onClick={event => this.handleClickDeleteUser(event, user)}
            >
              <DeleteIcon/>
              {this.props.sending && deletingUserEmail === user.email &&
              <CircularProgress size={58} className={classes.fabProgress} />}
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
    );
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    sending: state.users.sending,
  };
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, { deleteWaitingUser, removeUserRenters })
)(RenterAdminRow);



// WEBPACK FOOTER //
// ./src/components/Users/RenterAdminRow.jsx